export default {
    methods: {
        importAll (r) {
            let images = []
            r.keys().forEach((item) => images.push(item.replace('./', '')))
            return images
        }
    }
}
